import { Route, Routes } from "react-router-dom"

import { RiskZonesMapLayersRouter } from "../../../modules/riskZones/routers/RiskZonesMapLayersRouter"
import { SpeedingsMapLayersRouter } from "../../../modules/speedings/routers/SpeedingsMapLayersRouter"
import { MODULE_RISK_ZONES, MODULE_SPEEDINGS } from "../../constants/modules"

export const SafetyDesktopMapRouter = () => {

    return (
        <Routes>
            <Route
                element={
                    <RiskZonesMapLayersRouter />
                }
                path={`/${MODULE_RISK_ZONES}/*`}
            />
            <Route
                element={
                    <SpeedingsMapLayersRouter />
                }
                path={`/${MODULE_SPEEDINGS}/*`}
            />
        </Routes>
    )
}